import moment from 'moment-timezone';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getTrustTableData } from '../../../api/trust';
import { Layout } from '../../../common/components';
import NoReports from '../../../common/components/noReport/noReport';
import { useSetLoading } from '../../../common/hooks/appearance';
import { defaultTrustContractHeader } from '../../../utils/constant';
import * as handlers from '../../../utils/handlers';
import { TRUST_CONTRACT_TYPE_DTC } from '../../../utils/types';
import ContractDetails from '../components/contractDetails/contractDetails';
import GenerateTrust from '../components/generateTrust/generateTrust';
import ListOfContracts from '../components/tables/listOfContracts/listOfContracts';
import PaidTable from '../components/tables/paidTable/paidTable';
import PayableTable from '../components/tables/payableTable/payableTable';
import TrustTypes from '../components/trustTypes/trustTypes';

export default function TrustDefaults() {
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [applyFilters, setApplyFilters] = useState(false);
  const [showTable, setShowTable] = useState({
    show: false,
    tableName: '',
    tableData: [],
    date: null,
    fromDate: null,
    toDate: null,
    trustType: 0,
    needType: 0,
    totalResults: null,
    dynamicHeaders: [],
    agreementId: undefined,
    isCancelledContract: false,
    contractType: TRUST_CONTRACT_TYPE_DTC,
    page: 1,
    limit: 5,
    isSearchResult: false,
    hasDownloadFunctionality: true,
  });
  const paidTableRef = useRef(undefined);
  useEffect(() => {
    if (applyFilters && showTable?.show) {
      generateTable();
    }
    if (!showTable.show) {
      setApplyFilters(false);
    }
  }, [showTable]);

  const generateTable = async () => {
    setApplyFilters(false);
    const requestParams = {
      startDate: showTable.fromDate,
      endDate: showTable.toDate,
      timezone: moment.tz.guess(),
      trustType: showTable.trustType,
      needType: showTable.needType,
      contractType: showTable.contractType,
      search: undefined,
      page: showTable.page,
      limit: showTable.limit,
    };
    setLoading(true);
    try {
      const response = await getTrustTableData(
        {
          ...requestParams,
        },
        'filters',
      );

      const { data } = response || {};
      const { result, totalCount } = data || {};
      const agreementId = result?.length ? result[0].agreementId : undefined;
      const isCancelledContract = result?.length
        ? result[0]?.Agreement?.status?.toLowerCase() === 'cancelled'
        : false;

      setShowTable((state) => {
        const obj = {
          ...state,
          show: true,
          tableData: result || [],
          totalResults: totalCount || 0,
          dynamicHeaders: [],
          search: undefined,
        };

        obj.agreementId = agreementId;
        obj.isCancelledContract = isCancelledContract;

        return obj;
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handlers.apiErrorHandler(error);
    }
  };
  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <Layout>
      <TrustTypes setShowTable={setShowTable} setApplyFilters={setApplyFilters} />
      <GenerateTrust
        contractType={showTable?.contractType}
        setShowTable={setShowTable}
        trustType={showTable.trustType}
        needType={showTable.needType}
        title="Default Contracts"
        description="Generate a list of contracts which are defaulted in making
         Payment since 3 or more months."
      />
      <hr />
      {showTable.show ? (
        <ListOfContracts
          setShowTable={setShowTable}
          showTable={showTable}
          header={defaultTrustContractHeader}
          disabled={disabled}
          title="Defaulted Accounts"
          subtitle={`From: ${showTable?.fromDate} To: ${showTable?.toDate}`}
          subSubTitle={`No. of contracts: ${showTable?.totalResults}`}
          selectedAgreementID={showTable?.agreementId}
        />
      ) : (
        <div className="noreports-trust">
          <NoReports />
        </div>
      )}
      {showTable?.agreementId && showTable?.tableData?.length ? (
        <>
          <hr className="contractDetails-section" />
          <ContractDetails
            agreementId={showTable?.agreementId}
            isCancelledContract={showTable?.isCancelledContract}
            setDisabled={setDisabled}
          />
          <hr />
          <PayableTable
            paidTableRef={paidTableRef}
            agreementId={showTable?.agreementId}
            setDisabled={setDisabled}
          />
          <hr />
          <PaidTable ref={paidTableRef} agreementId={showTable?.agreementId} />
        </>
      ) : null}
    </Layout>
  );
}
